import { render, staticRenderFns } from "./document-classification-collapse.vue?vue&type=template&id=429cb219"
import script from "./document-classification-collapse.vue?vue&type=script&lang=js"
export * from "./document-classification-collapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports